/**
 * Where the apps are downloaded from: one place for the web app's gate badges and its install
 * sheet (src/components/StoreBadges.tsx, src/components/InstallHint.tsx). No imports: this file
 * runs in the Preact app and in Node's test runner.
 *
 * Neither store listing exists yet (docs/ios.md, docs/play.md), so both store URLs are null and
 * each badge links to the interim download: the public TestFlight link on iOS, the site's APK on
 * Android. When a listing exists, set its URL here and the badge links there. Google's badge terms
 * want the Google Play badge to link to Google Play, so the APK behind it is a stopgap the owner
 * accepted (2026-09-30).
 */

/** The App Store listing, once the app has one. Null until then. */
export const APP_STORE_URL: string | null = null;

/** The Google Play listing, once the app has one. Null until then. */
export const PLAY_STORE_URL: string | null = null;

/** The iOS app's public TestFlight link, the "Everyone" group (docs/ios.md). */
export const TESTFLIGHT_URL = "https://testflight.apple.com/join/cBEThG1c";

/** The signed Android app, hosted by the site (docs/android.md). */
export const APK_URL = "/app/omies-peons.apk";

/** The iOS download: the App Store listing when there is one, else TestFlight. */
export function iosDownloadUrl(appStoreUrl: string | null = APP_STORE_URL): string {
  return appStoreUrl || TESTFLIGHT_URL;
}

/** The Android download: the Google Play listing when there is one, else the site's APK. */
export function androidDownloadUrl(playStoreUrl: string | null = PLAY_STORE_URL): string {
  return playStoreUrl || APK_URL;
}
